import { render, staticRenderFns } from "./CarsTable.vue?vue&type=template&id=195e6a13&"
import script from "./CarsTable.vue?vue&type=script&lang=js&"
export * from "./CarsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports